import React from 'react';

var Scan = function Scan(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 9a1 1 0 1 1 2 0v6a1 1 0 0 1-2 0V9zm3.5 0a1 1 0 1 1 2 0v6a1 1 0 0 1-2 0V9zm3.25 0a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0V9zM16 9a1 1 0 0 1 2 0v6a1 1 0 0 1-2 0V9zM4.5 6v2a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-2zm2 12a1 1 0 0 1 0 2h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v2h2zm13-12h-2a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V6zm-2 12h2v-2a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 0 1 0-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Scan.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Scan as icon };
export default iconHandler(Scan);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Scan.js
// module id = 621
// module chunks = 0